// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".view-winners-button__wrapper[data-v-0f242a9e]{text-decoration:none}", ""]);
// Exports
module.exports = exports;
